/**
 * IOmeter Care – Cart Upsell
 * ---------------------------------------------------------
 * Zeigt "IOmeter Care" (12,90 €) als Empfehlung im Cart-Drawer
 * und auf der Cart-Seite (/cart), sobald ein IOmeter-Produkt
 * im Warenkorb liegt UND Care noch nicht selbst drin ist.
 *
 * EINBINDUNG:
 * 1. Diese Datei als Asset hochladen: Online Store > Themes >
 *    Code bearbeiten > Assets > "Datei hinzufügen" > iometer-care-upsell.js
 * 2. In layout/theme.liquid kurz vor </body> einfügen:
 *      <script src="{{ 'iometer-care-upsell.js' | asset_url }}" defer></script>
 * 3. CONFIG unten prüfen/anpassen (v.a. die Selectors — siehe Kommentare).
 * ---------------------------------------------------------
 */
(function () {
  "use strict";

  const CONFIG = {
    // Handle + SKU zur Identifikation von "IOmeter Care" — Preis, Titel,
    // Bild und Variant-ID werden live von Shopify geladen (nicht mehr fest
    // im Script hinterlegt), damit Preisänderungen automatisch übernommen werden.
    careHandle: "iometer-care-ihr-rundum-sorglos-paket",
    careSku: "IOmeterCare",

    // Fallback, falls der Live-Abruf ausnahmsweise fehlschlägt
    fallback: {
      title: "IOmeter Care: Ihr Rundum-Sorglos-Paket",
      priceFormatted: "12,99 €",
      teaser: "Onboarding, erweiterte Rückgabe, 24h-Austausch",
      image:
        "https://cdn.shopify.com/s/files/1/0869/9245/3963/files/care-frau.png?v=1784198810",
    },

    // Produkte, bei denen die Empfehlung erscheinen soll: alle mit
    // diesem product_type (trifft auf alle IOmeter-Kits/-Editionen zu)
    triggerProductType: "Energiemanagement",

    // --- Container: aus eurem cart-drawer.liquid bestätigt ---
    cartDrawerContainer: "#CartDrawer-CartItems",
    // Cart-Seite: aus eurem main-cart-items.liquid bestätigt. Bewusst OHNE
    // .cart__contents-Fallback: diese Klasse wird bei euch auch vom
    // Cart-Drawer-Formular selbst verwendet (#CartDrawer-Form), was zu einer
    // doppelten Einfügung führen kann.
    cartPageContainer: "#main-cart-items",

    // PV-Bestätigungsblock: es gibt bei euch zwei Varianten im Code
    // (inline in cart-drawer.liquid UND das Snippet betreiber-erklaerung.liquid).
    // Meine Karte wird IMMER direkt danach eingefügt, egal welche aktiv ist.
    pvAnchorSelectors: "#pv-confirmation, .pv-confirmation-box, #PvDeclaration, .pv-declaration",

    widgetId: "iometer-care-upsell-widget",
  };

  function formatMoney(cents) {
    return (
      (cents / 100).toLocaleString("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }) + " €"
    );
  }

  // Lädt Titel, Bild, Preis und Variant-ID live von Shopify (einmalig,
  // danach zwischengespeichert). So bleibt der angezeigte Preis immer aktuell.
  let careDataPromise = null;
  function fetchCareData() {
    if (careDataPromise) return careDataPromise;
    careDataPromise = fetch(`/products/${CONFIG.careHandle}.js`)
      .then((r) => {
        if (!r.ok) throw new Error("Product fetch failed");
        return r.json();
      })
      .then((product) => {
        const variant =
          product.variants.find((v) => v.sku === CONFIG.careSku) ||
          product.variants[0];
        return {
          variantId: variant.id,
          sku: variant.sku,
          title: product.title,
          image:
            (variant.featured_image && variant.featured_image.src) ||
            product.featured_image ||
            CONFIG.fallback.image,
          priceFormatted: formatMoney(variant.price),
        };
      })
      .catch(() => ({
        variantId: null,
        sku: CONFIG.careSku,
        ...CONFIG.fallback,
      }));
    return careDataPromise;
  }

  // Liest das Teaser-HTML (Aufzählungen, Links etc.) aus dem
  // <script id="iometer-care-teaser-data">, das per Liquid-Snippet aus dem
  // Rich-Text-Metafield custom.cart_teaser_rich befüllt wird.
  function getTeaserHtml() {
    try {
      const el = document.getElementById("iometer-care-teaser-data");
      if (!el) return CONFIG.fallback.teaser;
      const data = JSON.parse(el.textContent);
      return data.teaserHtml && data.teaserHtml.trim()
        ? data.teaserHtml.trim()
        : CONFIG.fallback.teaser;
    } catch (e) {
      return CONFIG.fallback.teaser;
    }
  }

  // Einmaliges CSS-Reset für das Rich-Text-HTML aus dem Metafield (Listen,
  // Links etc. kommen mit Shopifys Standard-Formatierung, die wir hier
  // kompakter machen, damit sie in die kleine Karte passt.
  function injectTeaserStyles() {
    if (document.getElementById("iometer-care-teaser-style")) return;
    const style = document.createElement("style");
    style.id = "iometer-care-teaser-style";
    style.textContent = `
      .iometer-care-teaser p { margin: 0; }
      .iometer-care-teaser ul, .iometer-care-teaser ol { margin: 2px 0 0; padding-left: 14px; }
      .iometer-care-teaser li { margin: 0; }
      .iometer-care-teaser a { color: #111; text-decoration: underline; }
    `;
    document.head.appendChild(style);
  }

  function fetchCart() {
    return fetch("/cart.js").then((r) => r.json());
  }

  function cartHasTrigger(cart) {
    return cart.items.some(
      (item) =>
        item.product_type === CONFIG.triggerProductType &&
        item.sku !== CONFIG.careSku
    );
  }

  function cartHasCare(cart) {
    return cart.items.some((item) => item.sku === CONFIG.careSku);
  }

  function buildWidget(care) {
    const wrapper = document.createElement("div");
    wrapper.id = CONFIG.widgetId;
    wrapper.style.cssText =
      "display:flex;gap:8px;align-items:center;padding:8px;margin:8px 0;border:1px solid #e5e5e5;border-radius:8px;background:#fafafa;";

    wrapper.innerHTML = `
      <a href="/products/${CONFIG.careHandle}" target="_blank" rel="noopener" style="flex-shrink:0;display:block;">
        <img src="${care.image}" alt="${care.title}" style="width:36px;height:36px;object-fit:cover;border-radius:5px;display:block;">
      </a>
      <div style="flex:1;min-width:0;">
        <a href="/products/${CONFIG.careHandle}" target="_blank" rel="noopener" style="font-size:12px;font-weight:600;line-height:1.25;color:inherit;text-decoration:none;">${care.title}</a>
        <div style="font-size:11px;color:#666;margin-top:1px;">${care.priceFormatted}</div>
        <div class="iometer-care-teaser" style="font-size:11px;color:#666;line-height:1.35;">${getTeaserHtml()}</div>
      </div>
      <button type="button" data-care-add style="flex-shrink:0;padding:6px 10px;font-size:12px;border:none;border-radius:6px;background:#111;color:#fff;cursor:pointer;white-space:nowrap;">
        +
      </button>
    `;

    wrapper.querySelector("[data-care-add]").addEventListener("click", (e) => {
      // Defensive: verhindert, dass der Klick von anderen document-level
      // capturing-Listenern (z.B. eurem PV-Checkbox-Handler) mitgelesen wird.
      e.stopPropagation();
      const btn = e.currentTarget;
      btn.disabled = true;
      btn.textContent = "…";
      addCareToCart(care).finally(() => {
        btn.textContent = "Hinzugefügt ✓";
      });
    });

    return wrapper;
  }

  function removeExistingWidgets() {
    document.querySelectorAll("#" + CONFIG.widgetId).forEach((el) => el.remove());
  }

  let hasAutoScrolled = false;

  function insertWidget(containerSelector, isDrawer, care) {
    // Bewusst nur der ERSTE Treffer: manche Landingpages (z.B. PageFly-Seiten
    // mit eigenem eingebettetem Header) rendern denselben Container/ID
    // versehentlich doppelt. Ohne diese Beschränkung würde die Karte dann
    // zweimal erscheinen.
    const container = document.querySelector(containerSelector);
    if (!container) return;
    if (container.querySelector("#" + CONFIG.widgetId)) return; // schon da
    const widget = buildWidget(care);
    // Bevorzugt: direkt nach dem PV-Bestätigungsblock einfügen (egal ob
    // inline .pv-confirmation-box oder Snippet .pv-declaration aktiv ist)
    const pvAnchor = container.querySelector(CONFIG.pvAnchorSelectors);
    if (pvAnchor) {
      pvAnchor.insertAdjacentElement("afterend", widget);
    } else {
      container.appendChild(widget);
    }
    // Im Drawer einmalig automatisch in den sichtbaren Bereich scrollen,
    // da #CartDrawer-CartItems eine scrollbare Zone mit begrenzter Höhe ist
    if (isDrawer && !hasAutoScrolled) {
      hasAutoScrolled = true;
      widget.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }

  function renderUpsell() {
    Promise.all([fetchCart(), fetchCareData()]).then(([cart, care]) => {
      removeExistingWidgets();
      if (cartHasTrigger(cart) && !cartHasCare(cart)) {
        insertWidget(CONFIG.cartDrawerContainer, true, care);
        insertWidget(CONFIG.cartPageContainer, false, care);
      } else {
        hasAutoScrolled = false; // erlaubt erneutes Auto-Scrollen, falls Bedingung später wieder zutrifft
      }
    });
  }

  function addCareToCart(care) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: care.variantId, quantity: 1 }],
      }),
    })
      .then((r) => {
        if (!r.ok) throw new Error("Add to cart failed");
        return r.json();
      })
      .then(() => refreshCartUI());
  }

  // Holt frische Section-HTML von Shopify und tauscht NUR den Artikelbereich
  // aus (Drawer + Cart-Seite + Icon-Bubble), damit Dawns eigene Artikelliste
  // den neu hinzugefügten Care-Artikel auch wirklich anzeigt.
  function refreshCartUI() {
    const sectionIds = ["cart-drawer", "cart-icon-bubble", "main-cart-items"];
    return fetch(`/?sections=${sectionIds.join(",")}`)
      .then((r) => {
        if (!r.ok) throw new Error("Section fetch failed");
        return r.json();
      })
      .then((html) => {
        const parser = new DOMParser();

        if (html["cart-drawer"]) {
          const doc = parser.parseFromString(html["cart-drawer"], "text/html");
          const fresh = doc.querySelector("#CartDrawer-CartItems");
          const live = document.querySelector("#CartDrawer-CartItems");
          if (fresh && live) live.innerHTML = fresh.innerHTML;
        }

        if (html["main-cart-items"]) {
          const doc = parser.parseFromString(html["main-cart-items"], "text/html");
          const fresh = doc.querySelector("#main-cart-items .js-contents");
          const live = document.querySelector("#main-cart-items .js-contents");
          if (fresh && live) live.innerHTML = fresh.innerHTML;
        }

        if (html["cart-icon-bubble"]) {
          const doc = parser.parseFromString(html["cart-icon-bubble"], "text/html");
          const live = document.querySelector("#cart-icon-bubble");
          if (live) live.innerHTML = doc.body.innerHTML;
        }

        renderUpsell(); // eigene Karte neu bewerten (verschwindet jetzt korrekt)
      })
      .catch(() => {
        // Fallback: falls Section-IDs bei euch anders heißen oder der Fetch
        // fehlschlägt, lieber zuverlässig neu laden als eine falsche Anzeige zeigen
        window.location.reload();
      });
  }

  // --- Robuster Trigger: MutationObserver statt fester Wartezeit ---
  // Dawn tauscht den Drawer-/Cart-Inhalt nach add/change/update per eigenem
  // AJAX-Section-Fetch aus (Timing variabel). Ein fixes setTimeout() nach
  // /cart/add.js kann daher zu früh feuern und von Dawns eigenem DOM-Swap
  // überschrieben werden. Der MutationObserver reagiert stattdessen direkt
  // auf jede tatsächliche DOM-Änderung, egal wie lange die dauert.
  let debounceTimer = null;

  function isOwnMutation(mutations) {
    // Ignoriert Mutationen, die NUR durch unser eigenes Widget entstanden
    // sind, um eine Endlosschleife (Insert -> Mutation -> Insert -> ...) zu vermeiden.
    return mutations.every((m) =>
      [...m.addedNodes, ...m.removedNodes].every(
        (n) => n.id === CONFIG.widgetId || n.nodeType !== 1
      )
    );
  }

  const observer = new MutationObserver((mutations) => {
    if (isOwnMutation(mutations)) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(renderUpsell, 30);
  });

  function startObserving() {
    injectTeaserStyles();
    observer.observe(document.body, { childList: true, subtree: true });
    renderUpsell();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startObserving);
  } else {
    startObserving();
  }

  // Zusätzliche explizite Trigger (falls euer Theme diese Events feuert)
  document.addEventListener("cart:updated", renderUpsell);
  document.addEventListener("cart:refresh", renderUpsell);
})();